<template>
  <el-upload
    :class="className || 'avatar-uploader'"
    ref="imageUpload"
      name="file"
      :accept="accept"
      :multiple="false"
      :action="uploadParams.host"
      :on-change="onChange"
      :data="uploadData"
      :show-file-list="false"
      :on-success="onFileSuccess"
      :on-error="onFileError"
      :on-progress="onProgress"
      :auto-upload="false"
      v-bind="$attrs"
  >
    <slot>
      <span>
        <div
          title="点击更改"
          class="upload-preview-box"
          v-if="imgSrc"
          :style="{ backgroundImage: `url('${imgSrc}')` }"
        >
          <i
            class="el-icon-circle-close"
            style="
              font-size: 24px;
              position: absolute;
              top: -10px;
              right: -10px;
              font-size: 24px;
            "
            @click.stop.prevent="removeImage"
          ></i>
        </div>
        <i title="点击上传" v-else class="el-icon-plus avatar-uploader-icon"
          ><span>上传图片</span></i
        >
      </span>
      <!-- <el-row v-show="progressShow" class="progress-el">
        <el-progress
          type="circle"
          class="progress"
          :percentage="percentage"
          :width="50"
        ></el-progress>
      </el-row> -->
      <div slot="tip" class="el-upload__tip" v-html="tip" v-if="tip"></div>
    </slot>
  </el-upload>
</template>

<style lang="scss">
.avatar-uploader {
  font-size: 0px;
  .el-upload {
    width: 120px !important;
    height: 120px !important;
    display: flex;
    margin-right: 10px;
    overflow: initial !important;
    position: relative;
    .progress-el {
      position: absolute;
      top: 28px;
      left: 35px;
      .progress {
        width: 50px;
        height: 50px;
        background-color: transparent;
      }
    }
  }
  .el-upload__tip {
    display: inline-block;
    line-height: 24px;
    font-size: 14px;
    color: #c5c5c5;
    vertical-align: bottom;
  }
}

.avatar-uploader-icon {
  font-size: 14px;
  width: 120px;
  height: 120px !important;
  line-height: 120px !important;
}

.upload-preview-box {
  width: 118px !important;
  height: 118px !important;
  position: relative;
  .el-icon-circle-close-outline {
    position: absolute;
    right: -8px;
    top: -8px;
    font-size: 20px;
    background: #ffffff;
    cursor: pointer;
    border-radius: 50%;
  }
}
</style>

<script>
import upFile from "../views/picture/assets/scripts/upFile";

export default {
  props: ["uploadedImg", "tip", "className", "currentIndex", "defaultImg"],
  data() {
    return {
      imgSrc: null, // 图片URL
      accept:
        "image/jpeg,image/gif,image/png,image/bmp,image/svg+xml,image/webp,video/*,", // 文件格式
      uploadParams: {
        // 上传参数
        host: "",
      },
    };
  },
  created() {},
  mounted() {
    this.imgSrc = this.uploadedImg;
  },
  computed: {
    uploadData() {
      return {
        policy: this.uploadParams.policy,
        signature: this.uploadParams.signature,
        OSSAccessKeyId: this.uploadParams.oss_accesskey_id,
        success_action_status: "200",
        name: this.filename,
        key: this.filename,
      };
    },
  },
  watch: {
    uploadedImg(val) {
      this.imgSrc = val;
    },
  },

  methods: {
    // 移除图片
    removeImage() {
      if (this.defaultImg) {
        this.imgSrc = this.defaultImg;
      } else {
        this.imgSrc = "";
      }
      this.$emit("uploaded", this.imgSrc, this.currentIndex);
    },
    // 图片选中回调
    async onChange(res) {
      if (res.status === "ready") {
        let imgSrc = await upFile(lib.api, "ec/c/tool/upload/auth/get", res);
        this.$emit("uploaded", imgSrc, res.name);
      }
    },
    // 图片上传成功
    onFileSuccess(res, file, fileList) {},
    // 图片上传失败
    onFileError() {},
    // 图片上传进度
    onProgress(res) {},
  },
};
</script>